// extracted by mini-css-extract-plugin
export default {"container":"CardCustomBoardContainer_container__+gX4x","board_wrapper":"CardCustomBoardContainer_board_wrapper__2UwlO"};